import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { CUSTOMER_ACCOUNT_TYPE_LABELS } from 'constants/customerAccountType';
import cn from 'utils/classnames';

import styles from './CustomerAccountTypeBadge.module.scss';

function CustomerAccountTypeBadge(props) {
  const { level, className, fallback } = props;

  if (!level) {
    return fallback ? (
      <span className={cn(styles.Component, className)}>{fallback}</span>
    ) : null;
  }

  return (
    <span
      className={cn(styles.Component, className)}
      data-account-type={level}
    >
      {CUSTOMER_ACCOUNT_TYPE_LABELS[level] || level}
    </span>
  );
}

CustomerAccountTypeBadge.propTypes = {
  level: PropTypes.string,
  className: PropTypes.string,
  fallback: PropTypes.node,
};

CustomerAccountTypeBadge.defaultProps = {
  level: '',
  className: '',
  fallback: null,
};

export default memo(CustomerAccountTypeBadge);
